<template lang="pug">
div
  .panel.is-primary
    .panel-heading Collections
    div(v-if='isFetching' class='panel-block')
      progress(class="progress is-small is-primary" max="100")
    div(v-if='!isFetching' class='panel-block')
      .container 
        b-menu
          b-menu-list(label="Your collections")
            b-menu-item(
              v-for="item in collections",
              :key="item.id",
              @click="() => { selectCollection(item.id); }",
              :label="item.name + ' (' + item.papersN.toString() + ')'",
              :active="item.id === selectedCollectionId"
            )
          b-menu-list(label="Shared to me")
            b-menu-item(
              v-for="item in sharedToMeCollections",
              :key="item.id",
              @click="() => { selectCollection(item.id); }",
              :label="item.name + ' (' + item.papersN.toString() + ')'",
            )
    div(v-if='!isFetching' class='panel-block')
      //collection menu
      .container
        .columns
          .column
            b-button(
              type="is-primary",
              expanded,
              @click="openCreateCollectionModal"
            icon-left='magic'
            ) Create new
          .column
            b-button(
              type="is-danger",
              expanded,
              :disabled="selectedCollectionId === null",
              @click="openShareCollectionModal"
              icon-left='edit'
            ) Edit
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState("collection", {
      collections: (s) => s.rawCollections,
      selectedCollectionId: (s) => s.selectedCollectionId,
      sharedToMeCollections: (s) => s.rawSharedToMeCollections,
      isFetching: s=>s.isFetchingCollection
    }),
  },
  methods: {
    ...mapMutations("createCollection", {
      openCreateCollectionModal: "openModal",
    }),
    ...mapMutations("shareCollection", {
      openShareCollectionModal: "openModal",
    }),
    ...mapActions("collection", ["fetchCollectionPapers"]),
    async selectCollection(collectionId) {
      await this.fetchCollectionPapers({ collectionId });
    },
  },
};
</script>